'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 1.5em;\n  text-align: center;\n  color: #222222;\n  font-size: 20px;\n  font-weight: 600;\n  margin-right: 10px;\n  line-height: 64px;\n  cursor: pointer;\n\n'], ['\n  font-size: 1.5em;\n  text-align: center;\n  color: #222222;\n  font-size: 20px;\n  font-weight: 600;\n  margin-right: 10px;\n  line-height: 64px;\n  cursor: pointer;\n\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: #b8c2cb;\n'], ['\n  color: #b8c2cb;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  min-width: 170px;\n  background: white;\n  text-align: center;\n  border-radius: 6px;\n'], ['\n  min-width: 170px;\n  background: white;\n  text-align: center;\n  border-radius: 6px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Span = _styledComponents2.default.span(_templateObject);
var SelectedSpan = Span.extend(_templateObject2);
var Wrapper = _styledComponents2.default.div(_templateObject3);
var DateEditor = function DateEditor(props) {
  var onDateClick = props.onDateClick,
      onMonthClick = props.onMonthClick,
      onYearClick = props.onYearClick,
      date = props.date,
      format = props.format,
      viewFor = props.viewFor,
      maxDate = props.maxDate,
      minDate = props.minDate,
      lang = props.lang;

  _moment2.default.locale(lang || 'en');
  var defaultDate = (0, _moment2.default)(date || (0, _moment2.default)(), format || 'DD-MM-YYYY').isBetween(minDate || (0, _moment2.default)().subtract(1, 'days'), maxDate || (0, _moment2.default)().add(1, 'days')) ? (0, _moment2.default)() : maxDate && (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').isSameOrAfter(date) ? (0, _moment2.default)() : minDate && (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').isSameOrBefore(date) ? (0, _moment2.default)() : maxDate ? (0, _moment2.default)(maxDate, format || 'DD-MM-YYYY').subtract(1, 'days') : minDate ? (0, _moment2.default)(minDate, format || 'DD-MM-YYYY').add(1, 'days') : (0, _moment2.default)();
  var day = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY').format('DD') : defaultDate.format('DD');
  var month = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY').format('MMM') : defaultDate.format('MMM');
  var year = date ? (0, _moment2.default)(date, format || 'DD-MM-YYYY').format('YYYY') : defaultDate.format('YYYY');
  return _react2.default.createElement(
    Wrapper,
    null,
    viewFor !== 'date' ? _react2.default.createElement(
      SelectedSpan,
      { onClick: onDateClick },
      day
    ) : _react2.default.createElement(
      Span,
      { onClick: onDateClick },
      day
    ),
    viewFor !== 'month' ? _react2.default.createElement(
      SelectedSpan,
      { onClick: onMonthClick },
      month
    ) : _react2.default.createElement(
      Span,
      { onClick: onMonthClick },
      month
    ),
    viewFor !== 'year' ? _react2.default.createElement(
      SelectedSpan,
      { onClick: onYearClick },
      year
    ) : _react2.default.createElement(
      Span,
      { onClick: onYearClick },
      year
    )
  );
};
DateEditor.propTypes = {
  date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  format: _propTypes2.default.string,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  onDateClick: _propTypes2.default.func,
  onMonthClick: _propTypes2.default.func,
  onYearClick: _propTypes2.default.func,
  viewFor: _propTypes2.default.string
};
exports.default = DateEditor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modern-datepicker/build/elements/DateEditor.js
// module id = 484
// module chunks = 0